import { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router';

import { useGameDetails, useHistoricRound } from 'utils/Hooks';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Arrow from 'assets/icons/Arrow.svg';
import { faArrowAltCircleUp, faArrowAltCircleDown, faCircleDot } from "@fortawesome/free-solid-svg-icons";
import './styles.scss';

function Section(props) {
  const roundStatus = Object.freeze({
    bull: 0,
    bear: 1,
    other: 2,
  });

  const gameDetails = useGameDetails();
  const round = useHistoricRound(props.roundID);
  const [status, SetStatus] = useState(null);
  const detailsUrlM = useMemo(GetDetailsURL, [gameDetails, round]);

  useEffect(() => {
    UpdateStatus();
  }, [round, props.roundID]); // eslint-disable-line react-hooks/exhaustive-deps

  async function UpdateStatus() {
    const newStatus = DetermineRoundStatus();
    SetStatus(newStatus);
  }

  function DetermineRoundStatus() {
    if (!round || !round.epoch) return null;
    let status;
    const lockPrice = Number(round.lockPrice);
    const closePrice = Number(round.closePrice);
    if (round.canceled || !round.closed)
      status = roundStatus.other;
    else if (lockPrice > closePrice)
      status = roundStatus.bear;
    else if (lockPrice < closePrice)
      status = roundStatus.bull;
    else
      status = roundStatus.other;
    return status;
  }

  function GetDetailsURL() {
    return ('/history/' + gameDetails.chainName.toLowerCase() + '/'
      + gameDetails.tickerSymbol.toLowerCase() + `/round/${round.epoch}`);
  }

  function StyledRoundID() {
    const referenceSize = 0.7; // for 4 digit rounds
    const length = props.roundID?.toString().length;
    let effectiveSize, effectiveLineHeight = 1.2;
    let formattedID = props.roundID;
    if (length < 4) {
      effectiveSize = referenceSize * 1.2;
      effectiveLineHeight = 1
    } else if (length > 4 && length <= 5) {
      effectiveSize = referenceSize * 1;
    } else if (length > 5) {
      effectiveSize = referenceSize;
      formattedID = ".." + props.roundID.toString().slice(-3);
    } else {
      effectiveSize = referenceSize;
    }
    const formattedSize = effectiveSize.toFixed(2) + "em";
    const formattedHeight = effectiveLineHeight.toFixed(2) + "em";
    return <p className='RoundNumber' style={{ fontSize: formattedSize, lineHeight: formattedHeight }}>
      {formattedID}
    </p>;
  }

  /* eslint-disable jsx-a11y/alt-text */
  function RoundColumns() {
    let column1;
    let column2;
    switch (status) {
      case roundStatus.bear:
        column1 = (<FontAwesomeIcon icon={faArrowAltCircleDown} className='BearRed' size='2x' />);
        column2 = (<div className='BearRed bold'>{StyledRoundID()}</div>);
        break;
      case roundStatus.bull:
        column1 = (<FontAwesomeIcon icon={faArrowAltCircleUp} className='BullGreen' size='2x' />);
        column2 = (<div className='BullGreen bold'>{StyledRoundID()}</div>);
        break;
      case roundStatus.other:
        column1 = (<FontAwesomeIcon icon={faCircleDot} className='ThemeWhite' size='2x' />);
        column2 = (<div className='ThemeWhite bold'>{StyledRoundID()}</div>);
        break;
      default:
        column1 = null;
        column2 = null;
        break;
    }
    return (
      <Link className='Section' to={detailsUrlM}>
        {column1}
        {column2}
      </Link>
    );
  }


  if (!props.roundID || status === null)
    return <p style={{ color: 'blueviolet' }}>Loading...</p>;
  else
    return RoundColumns();
}

export default Section;
